import React, { useEffect, useState } from "react";
import "./index.css";
import "./App.scss";
import { Layout, Menu, Dropdown, BackTop, Badge, Space } from "antd";
import { Auth } from "aws-amplify";
import { observer } from "mobx-react";
import { myHistory } from "./common/History";
import { Route } from "react-router-dom";
import { Org } from "./pages/organization/Org";
import { Dashboard } from "./pages/dashboard/Dashboard";
import { Store } from "./store/Store";
import { LogoutOutlined } from "@ant-design/icons";
import { Fundraisers } from "./pages/fundraising/Fundraisers";
import { Fundraiser } from "./pages/fundraising/Fundraiser";
import { Aws } from "./common/Aws";
import { User } from "./pages/user/User";
import { Feedbacks } from "./pages/feedback/Feedbacks";
import { Child } from "./pages/children/Child";
import { Changes } from "./pages/change/Change";
import { EngToolActivities } from "./pages/engagement/ToolActivities";
import { EngToolWorkSubmissions } from "./pages/engagement/ToolWorkSubmissions";
import { Articles } from "./pages/content/Articles";
import { Communities } from "./pages/community/Communities";
import { Community } from "./pages/community/Community";
import { ArticleComments } from "./pages/content/ArticleComments";
import { ArticlePublishHistory } from "./pages/content/ArticlePublishHistory";
import { Reports } from "./pages/report/Reports";
import { AppVersions } from "./pages/setting/appversion/AppVersions";
import { Users } from "./pages/user/Users";
import { PendingOrgs } from "./pages/organization/pending/PendingOrgs";
import { ChannelInvitations } from "./pages/marketing/invitation/ChannelInvitations";
import { Activities } from "./pages/marketing/activity/Activities";
import Avatar from "antd/lib/avatar/avatar";
import { UserActivities } from "./pages/activities";
import { EngActivities } from "./pages/engagement/EngActivities";
import { Orgs } from "./pages/organization/Orgs";
import { Roles } from "./pages/admin/role/Roles";
import { Employees } from "./pages/admin/employee/Employees";
import { Regions } from "./pages/admin/region/Regions";
import { Interests } from "./pages/setting/interest/Interests";
import { SystemSettings } from "./pages/setting/system/SystemSettings";
import { ShareEduOfferUsers } from "./pages/user/ShareEduOfferUsers";
import { Banners } from "./pages/banner/Banners";
import { EduShareOfferStats } from "./pages/edushare";
import { Posts } from "./pages/content/post/Posts";
import { PostComments } from "./pages/content/post/PostComments";
import { Volunteers } from "./pages/volunteer/Volunteers";
import { Volunteer } from "./pages/volunteer/Volunteer";
import { IdCheck2Page } from "./pages/idCheck/IdCheck2";
import { useAppContext } from "./components/AppProvider";
const { Header, Sider } = Layout;

export const App = observer(() => {
  const { me, loadMe } = useAppContext();
  const [shortName, setShortName] = useState("FM");
  const [name, setName] = useState("");
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    Store.setCurMenu([myHistory.location.pathname.slice(1) || "dashobard"]);
    Auth.currentAuthenticatedUser()
      .then(async (user) => {
        Store.user = user;
        const name = `${user.attributes["given_name"]} ${user.attributes["family_name"]}`;
        const shortName = name
          .split(" ")
          .map((x) => x[0])
          .join("")
          .toUpperCase();
        setShortName(shortName);
        setName(name);

        Store.isAdmin = await Aws.isManaging();
        Store.isDivision = await Aws.isDivision();
        Store.start = true;
        Store.updateUnreadMsg();

        loadMe();
      })
      .catch((err) => {
        console.log("xx", err);
        myHistory.push("/login");
      });
  }, []);

  const logout = () => {
    Auth.signOut().then(() => myHistory.push("/login"));
  };

  const onMenu = ({ item, key }) => {
    Store.curMenu = [key];
    myHistory.push(`/${key}`);
  };

  const menu = (
    <Menu onClick={logout}>
      <Menu.Item key="logout">
        <LogoutOutlined />
        Logout
      </Menu.Item>
    </Menu>
  );
  return (
    <Layout className="layout" style={{ minHeight: "100vh" }}>
      <Sider collapsed={collapsed} onCollapse={setCollapsed} width={240}>
        <div className="logo">
          <a href="/">
            <img src="/logo.png" alt="logo" />
            <h1>FooMoo Admin</h1>
          </a>
        </div>

        <Menu theme="dark" mode="inline" selectedKeys={Store.curMenu} onClick={onMenu}>
          {me.isAuthRes("Dashboard") && <Menu.Item key="dashboard">Dashboard</Menu.Item>}
          {me.isAuthRes("Banners") && <Menu.Item key="banners">Banners</Menu.Item>}
          {me.isAuthRes("Users") && <Menu.Item key="users">Users</Menu.Item>}
          {me.isAuthRes("UserActivities") && <Menu.Item key="activities">User Activities</Menu.Item>}
          {me.isAuthRes("EduShare") && (
            <Menu.SubMenu title="eduShare" key="edushare">
              {me.isAuthRes("EduShareOfferStats") && <Menu.Item key="edushare/stats">Interested & Request</Menu.Item>}
              {me.isAuthRes("EduShareOfferUsers") && <Menu.Item key="edushare/users">Offer Users</Menu.Item>}
            </Menu.SubMenu>
          )}

          {me.isAuthRes("Feedback") && (
            <Menu.Item key="feedbacks">
              <Space>
                Feedback
                <Badge count={Store.unread.feedback}></Badge>
              </Space>
            </Menu.Item>
          )}
          {me.isAuthRes("ChangeRequest") && (
            <Menu.Item key="change">
              <Space>
                Change Request
                <Badge count={Store.unread.childUpdate}></Badge>
              </Space>
            </Menu.Item>
          )}
          {me.isAuthRes("IDCheck") && (
            <Menu.Item key="idcheck">
              <Space>
                ID Check
                <Badge count={Store.unread.idCheck}></Badge>
              </Space>
            </Menu.Item>
          )}
          {me.isAuthRes("Marketing") && (
            <Menu.SubMenu title="Marketing Campaign" key="marketing">
              {me.isAuthRes("Invitation") && <Menu.Item key="marketing/invitation">Invitation</Menu.Item>}

              {/* <Menu.Item key="marketing/activity">Activity</Menu.Item> */}
            </Menu.SubMenu>
          )}
          {me.isAuthRes("Content") && (
            <Menu.SubMenu title="Content" key="content">
              {me.isAuthRes("ContentArticles") && (
                <Menu.Item key="content/articles">
                  <Space>
                    Articles <Badge></Badge>
                  </Space>
                </Menu.Item>
              )}
              {me.isAuthRes("ContentPosts") && (
                <Menu.Item key="content/posts">
                  <Space>Posts</Space>
                </Menu.Item>
              )}
              {me.isAuthRes("ContentPostComments") && (
                <Menu.Item key="content/post-comments">
                  <Space>Post Comments</Space>
                </Menu.Item>
              )}
            </Menu.SubMenu>
          )}
          {me.isAuthRes("Volunteer") && (
            <Menu.Item key="volunteers">
              <Space>Volunteer</Space>
            </Menu.Item>
          )}
          {me.isAuthRes("Fundraising") && (
            <Menu.Item key="fundraisers">
              <Space>
                Fundraising
                <Badge count={Store.unread.fundPending}></Badge>
              </Space>
            </Menu.Item>
          )}
          {me.isAuthRes("Engagement") && (
            <Menu.SubMenu title="Engagement Tool" key="eng-tool">
              {me.isAuthRes("EngagementActivities") && (
                <Menu.Item key="eng-tool/activities">Engagement Activities</Menu.Item>
              )}
              {me.isAuthRes("EngagementTitleDescription") && <Menu.Item key="eng-tool/ad">Title Description</Menu.Item>}
              {me.isAuthRes("EngagementWorkSubmission") && <Menu.Item key="eng-tool/ws">Work Submission</Menu.Item>}
            </Menu.SubMenu>
          )}
          {me.isAuthRes("SchoolAddition") && (
            <Menu.Item key="user-schools">
              <Space>
                User School Addition
                <Badge count={Store.unread.orgPending}></Badge>
              </Space>
            </Menu.Item>
          )}
          {me.isAuthRes("Organizations") && <Menu.Item key="orgs">Organizations</Menu.Item>}
          {me.isAuthRes("Community") && <Menu.Item key="communities">Community</Menu.Item>}

          {me.isAuthRes("Admin") && (
            <Menu.SubMenu title="Admin" key="admin">
              {me.isAuthRes("Employeements") && <Menu.Item key="admin/employees">Employees</Menu.Item>}
              {me.isAuthRes("Regions") && <Menu.Item key="admin/regions">Regions</Menu.Item>}
              {me.isAuthRes("Roles") && <Menu.Item key="admin/roles">Roles</Menu.Item>}
            </Menu.SubMenu>
          )}

          {me.isAuthRes("Settings") && (
            <Menu.SubMenu title="Settings" key="settings">
              {me.isAuthRes("AppVersions") && <Menu.Item key="settings/appversion">App Versions</Menu.Item>}
              {me.isAuthRes("Interest") && <Menu.Item key="settings/interest">Interest List</Menu.Item>}
              {me.isAuthRes("SystemSettings") && <Menu.Item key="settings/system">System</Menu.Item>}
            </Menu.SubMenu>
          )}

          {me.isAuthRes("Report") && <Menu.Item key="reports">Report</Menu.Item>}
        </Menu>
      </Sider>
      <Layout>
        <Header style={{ zIndex: 1000 }}>
          <div className="top-header">
            <div className="top-header-right">
              <Dropdown overlay={menu} className="index-action">
                <Space>
                  <Avatar>{shortName}</Avatar> {name}
                </Space>
              </Dropdown>
            </div>
          </div>
        </Header>
        <Layout style={{ marginTop: 0 }}>
          <Route path="/" exact component={Dashboard} />
          <Route path="/dashboard" component={Dashboard} />
          <Route path="/users" exact component={Users} />
          <Route path="/banners" exact component={Banners} />
          <Route path="/edushare/stats" exact component={EduShareOfferStats} />
          <Route path="/edushare/users" exact component={ShareEduOfferUsers} />
          <Route path="/activities" exact component={UserActivities} />
          <Route path="/change" exact component={Changes} />
          <Route path="/idcheck" exact component={IdCheck2Page} />
          <Route path="/users/:id" component={User} />
          <Route path="/children/:id" component={Child} />
          <Route path="/communities" exact component={Communities} />
          <Route path="/communities/:id" component={Community} />
          <Route path="/user-schools" exact component={PendingOrgs} />
          <Route path="/orgs" exact component={Orgs} />
          <Route path={["/orgs/:id/:tab", "/orgs/:id"]} component={Org} />
          <Route path="/fundraisers" exact component={Fundraisers} />
          <Route path="/fundraisers/:id" component={Fundraiser} />
          <Route path="/feedbacks" exact component={Feedbacks} />

          <Route path="/volunteers" exact component={Volunteers} />
          <Route path="/volunteers/:id" component={Volunteer} />

          <Route path="/content/posts" exact component={Posts} />
          <Route path="/content/post-comments" exact component={PostComments} />
          <Route path="/content/articles" exact component={Articles} />

          <Route path="/content/:id/comments" component={ArticleComments} />
          <Route path="/content/:id/publishing" component={ArticlePublishHistory} />

          <Route path="/admin/roles" component={Roles} />
          <Route path="/admin/employees" component={Employees} />
          <Route path="/admin/regions" component={Regions} />

          <Route path="/settings/appversion" component={AppVersions} />
          <Route path="/settings/interest" component={Interests} />
          <Route path="/settings/system" component={SystemSettings} />

          <Route path="/marketing/invitation" exact component={ChannelInvitations} />
          <Route path="/marketing/activity" exact component={Activities} />
          <Route path="/reports" component={Reports} />
          <Route path="/eng-tool/activities" component={EngActivities} />
          <Route path="/eng-tool/ad" component={EngToolActivities} />
          <Route path="/eng-tool/ws" component={EngToolWorkSubmissions} />
          <BackTop />
        </Layout>
      </Layout>
    </Layout>
  );
});
